import { render, staticRenderFns } from "./addpayment_ar.vue?vue&type=template&id=3b271b99&"
import script from "./addpayment_ar.vue?vue&type=script&lang=js&"
export * from "./addpayment_ar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports